import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {MapComponent} from '../map.component';
import {MapService} from '../../../commons/map.service';
import {Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {AppBaseComponent} from '../../../commons/AppBaseComponent';
import {AppService} from '../../../commons/app.service';
import {FourDService} from '4d-mapper';
import { XsApplicationEventsService } from '../../../xs/services/events/application-events.service';

const Cesium = (<any>window).Cesium

@Component({
  selector: 'lock-camera',
  templateUrl: './lock-camera.component.html',
  styleUrls: ['./lock-camera.component.scss']
})
export class LockCameraComponent extends AppBaseComponent implements OnInit, OnDestroy {


  constructor(public fourD: FourDService, public service: AppService, public router: Router,
              public snackBar: MatSnackBar, public dialog: MatDialog, public mapService: MapService, public mapComp: MapComponent, applicationEvents:XsApplicationEventsService) {
    super(service, router, snackBar, dialog, applicationEvents);
  }

  lock(){
        if(this.mapComp && this.mapComp.refPin && this.mapComp.refPin.position){
          try{
            if(this.mapService.newAnnotation){
              this.mapService.flyTo(this.mapService.newAnnotation);
              this.mapService.viewer.trackedEntity = this.mapService.helper.getCesiumObjectFor(this.mapService.newAnnotation).pin;
            }else{
                this.mapService.flyToRefPin(this.mapComp.refPin);
              this.mapService.viewer.trackedEntity = this.mapComp.refPin;
            }


              this.mapComp.cameraLocked = true;
          }catch (e) {
            console.log(e);
          }
        }else{
          this.openSnackBarWarn('MAP.CAMERA_CLICK');
        }
      }
     unlock(){
         this.mapComp.cameraLocked = false;
         this.mapService.viewer.trackedEntity = undefined;
       }

      ngOnDestroy(): void {
      }

}
